import OrderU8 from './order-u8.vue';
export default OrderU8;
